import * as yup from "yup";
import { locationSchema } from "../../Components/Booking/booking.schema";

export const checkoutSchema = yup.object({
  userId: yup.string().required(),
  flightName: yup.string().required(),
  pickupDate: yup.string().required(),
  pickupTime: yup.string().required(),
  locations: yup.array().required().min(2).max(5).of(locationSchema),
  fleetId: yup.string().required(),
  totalCost: yup.object({
    amount: yup.number().required().min(0),
    currencyCode: yup.string().required(),
  }),
});

export type checkoutType = yup.InferType<typeof checkoutSchema>;
